angular.module('dnecom')
    .controller('MockupProcessSimulatorController', ["$scope", "$http", "$timeout", "notifications", "Upload", "MediaUtils", "MediaSrc", function MockupProcessSimulatorController($scope, $http, $timeout, notifications, Upload, MediaUtils, MediaSrc) {
        $scope.colorSelectorVisible = false;
        $scope.generatingMockup = false;

        var CHECK_TASK_INTERVAL = 5000; // 5 seconds

        $scope.init = function() {
            if (!$scope.mockup.designs) {
                $scope.mockup.designs = [];
            }

            if (!$scope.mockup.properties || Array.isArray($scope.mockup.properties)) {
                $scope.mockup.properties = {};
            }

            if (!$scope.mockup.properties.selectedDesign || Array.isArray($scope.mockup.properties.selectedDesign)) {
                $scope.mockup.properties.selectedDesign = {
                    'front': getDefaultDesignSettings()
                };
            }

            $scope.mockup.currentTemplate = 'front';

            if (!$scope.mockup.properties.images) {
                $scope.mockup.properties.images = {};
            }

            $scope.$on('draggableImg.update', function($event, element) {
                $scope.mockup.properties.selectedDesign[$scope.mockup.currentTemplate] = {
                    'x': element.data('x'),
                    'y': element.data('y'),
                    'width': element.width(),
                    'height': element.height(),
                    'media': $scope.mockup.properties.selectedDesign[$scope.mockup.currentTemplate].media
                };
            });

            if ($scope.mockup.properties.selectedColor) {
                $timeout(drawGrid);
            }
        };

        $scope.toggleColorSelector = function() {
            $scope.colorSelectorVisible = !$scope.colorSelectorVisible;
        };

        $scope.isColorSelectorVisible = function() {
            return $scope.colorSelectorVisible;
        };

        $scope.selectColor = function(color) {
            if ($scope.isColorSelected(color)) {
                return;
            }

            if (!$scope.getAvailableTemplates(color).length) {
                notifications.danger('No templates available for this color.');
                return;
            }

            $scope.mockup.properties.selectedColor = color;
            $scope.colorSelectorVisible = false;

            $timeout(drawGrid);
        };

        $scope.isColorSelected = function(color) {
            if (!$scope.mockup.properties || !$scope.mockup.properties.selectedColors) {
                return false;
            }

            var result = false;

            angular.forEach($scope.mockup.properties.selectedColors, function(item) {
                if (areColorsEqual(item, color)) {
                    result = true;
                }
            });

            return result;
        };

        $scope.getSimulatorImageUrl = function() {
            if (!$scope.mockup.properties.selectedColor) {
                return '';
            }

            var imageUrl = '';

            angular.forEach($scope.mockup.properties.selectedColor.images, function(image, side) {
                if (side == $scope.mockup.currentTemplate || !imageUrl) {
                    imageUrl = image.url;
                }
            });

            return imageUrl;
        };

        $scope.centerDesignImageHorizontally = function($event) {
            $event.preventDefault();
            $scope.$broadcast('draggableImg.centerHorizontally');
        };

        $scope.centerDesignImageVertically = function($event) {
            $event.preventDefault();
            $scope.$broadcast('draggableImg.centerVertically');
        };

        $scope.getAvailableTemplates = function(color) {
            if (!color) {
                color = $scope.mockup.properties.selectedColor;
            }

            if (!color) {
                return [];
            }

            var images = [];

            angular.forEach(color.images, function(image, side) {
                if ($scope.mockup.product.templates[side]) {
                    images.push(image);
                }
            });

            return images;
        };

        $scope.selectDesign = function(design) {
            if (!$scope.mockup.properties.selectedDesign[design.location]) {
                $scope.mockup.properties.selectedDesign[design.location] = getDefaultDesignSettings();
            }

            $scope.mockup.properties.selectedDesign[design.location].media = design.media;

            $scope.mockup.currentTemplate = design.location;
            $scope.mockup.properties.selectedSide = design.location.toLowerCase();

            $scope.$broadcast('draggableImg.updatePosition', $scope.mockup.properties.selectedDesign[design.location]);
        };

        $scope.getPreviewImageUrl = function() {
            var design = $scope.mockup.properties.selectedDesign[$scope.mockup.currentTemplate];
            var media = design ? design.media : null;

            return media ? MediaSrc.src(media) : '';
        };

        $scope.resetSelection = function($event) {
            $event.preventDefault();
            $scope.mockup.properties.selectedColor = null;
            $scope.colorSelectorVisible = true;
        };

        $scope.isGeneratingMockup = function() {
            return $scope.generatingMockup;
        };

        $scope.cancelMockupGeneration = function($event) {
            $event.preventDefault();
            $scope.generatingMockup = false;
        };

        $scope.generateMockup = function($event) {
            $event.preventDefault();

            $scope.generatingMockup = true;

            $http.post(
                Routing.generate('mockup_generate', {
                    id: $scope.mockup.id || 0
                }),
                $scope.mockup
            ).then(function(response) {
                if (!response.data.success) {
                    notifications.danger(response.data.message || 'Failed to generate mockup.');
                    return;
                }

                if (response.data.mockup) {
                    afterMockupGeneration(response.data.mockup);
                } else if (response.data.taskId) {
                    $scope.mockup.properties.taskId = response.data.taskId;
                    $timeout(checkTask, CHECK_TASK_INTERVAL);
                } else {
                    notifications.danger('Invalid API response');
                    $scope.generatingMockup = false;
                }
            }, function() {
                notifications.danger('Invalid server response.');
                $scope.generatingMockup = false;
            });
        };

        var checkTask = function() {
            if (!$scope.isGeneratingMockup()) {
                return;
            }

            $http.get(
                Routing.generate('mockup_check_task', {
                    accountId: $scope.mockup.provider,
                    taskId: $scope.mockup.properties.taskId
                })
            ).then(function(response) {
                if (!response.data.success || response.data.status == 'pending') {
                    $timeout(checkTask, CHECK_TASK_INTERVAL);
                    return;
                }

                if (response.data.status == 'completed') {
                    afterMockupGeneration(response.data.mockup);
                } else {
                    notifications.danger(response.data.error || 'Mockup generation failed.');
                    $scope.generatingMockup = false;
                }
            }, function() {
                notifications.danger('Invalid server response.');
                $timeout(checkTask, CHECK_TASK_INTERVAL);
            });
        };

        var afterMockupGeneration = function(result) {
            notifications.success('Mockup generated successfully.');

            var color = $scope.mockup.properties.selectedColor;

            $scope.mockup.properties.images[color.name] = result;

            if (!$scope.mockup.properties.selectedColors) {
                $scope.mockup.properties.selectedColors = [];
            }

            if ($scope.mockup.properties.selectedColors.indexOf(color) == -1) {
                $scope.mockup.properties.selectedColors.push(color);
            }

            $scope.mockup.properties.selectedColor = null;

            $scope.generatingMockup = false;
        };

        var getDefaultDesignSettings = function() {
            return {
                'x': 0,
                'y': 0,
                'width': 100,
                'height': 100
            };
        };

        var areColorsEqual = function(color1, color2) {
            if (!color1 || !color2) {
                return false;
            }

            return color1.hex == color2.hex && color1.name == color2.name;
        };

        var drawGrid = function() {
            var $canvas = $('.mockup-generator canvas');
            var ctx = $canvas.get(0).getContext('2d');

            ctx.canvas.width  = $canvas.width();
            ctx.canvas.height = $canvas.height();

            ctx.strokeStyle = '#97C0FD';
            ctx.lineWidth = 1;

            for (x = 0; x <= ctx.canvas.width; x += 30) {
                ctx.moveTo(x, 0);
                ctx.lineTo(x, ctx.canvas.height);
            }

            for (y = 0; y <= ctx.canvas.height; y += 30) {
                ctx.moveTo(0, y);
                ctx.lineTo(ctx.canvas.width, y);
            }

            ctx.stroke();
        };
    }]);
